import { Link } from "react-router-dom";
import { articles } from "../../../mocks/articles";

export default function AnalysisHighlights() {
  const featured = articles.filter((a) => a.featured).slice(0, 3);
  const hero = featured[0];

  return (
    <section className="bg-background-100/70">
      <div className="mx-auto max-w-7xl px-4 md:px-6 py-16 md:py-20">
        <div className="flex flex-col items-start justify-between gap-4 sm:flex-row sm:items-end">
          <div>
            <p className="text-sm text-primary-600 font-medium">剧情深度解析</p>
            <h2 className="mt-2 font-display text-3xl text-foreground-950 md:text-4xl">
              看懂剧情背后的深意
            </h2>
            <p className="mt-3 max-w-xl text-sm leading-6 text-foreground-700">
              守护蛋、X 蛋、复活社与角色们的心路历程——不只讲发生了什么，更帮你读懂为什么。
            </p>
          </div>
          <Link
            to="/analysis"
            className="inline-flex items-center gap-2 rounded-full bg-primary-500 px-5 py-2.5 text-sm text-background-50 whitespace-nowrap hover:bg-primary-600"
          >
            全部解析
            <i className="ri-arrow-right-line" />
          </Link>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-6 lg:grid-cols-3">
          <Link
            to={`/analysis/${hero.id}`}
            className="group relative overflow-hidden rounded-2xl lg:col-span-2 lg:row-span-2"
          >
            <img
              src={hero.cover}
              alt={hero.title}
              className="h-72 w-full object-cover object-top transition-transform duration-300 group-hover:scale-105 lg:h-full"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/85 via-foreground-950/20 to-transparent" />
            <div className="absolute inset-x-0 bottom-0 p-6">
              <span className="inline-flex rounded-full bg-accent-500 px-3 py-1 text-xs font-medium text-foreground-950">
                {hero.category}
              </span>
              <h3 className="mt-3 font-display text-2xl text-background-50">{hero.title}</h3>
              <p className="mt-2 hidden text-sm leading-6 text-background-50/85 sm:line-clamp-2">
                {hero.summary}
              </p>
              <span className="mt-3 inline-flex items-center gap-1 text-sm text-accent-300">
                阅读全文 <i className="ri-arrow-right-line" />
              </span>
            </div>
          </Link>

          {featured.slice(1).map((a) => (
            <Link
              key={a.id}
              to={`/analysis/${a.id}`}
              className="group overflow-hidden rounded-2xl border border-background-200/70 bg-background-50 transition-colors hover:border-primary-200"
            >
              <div className="h-40 overflow-hidden">
                <img
                  src={a.cover}
                  alt={a.title}
                  className="h-full w-full object-cover object-top transition-transform duration-300 group-hover:scale-105"
                />
              </div>
              <div className="p-5">
                <span className="inline-flex rounded-full bg-secondary-100 px-3 py-1 text-xs font-medium text-secondary-800">
                  {a.category}
                </span>
                <h3 className="mt-3 font-medium text-foreground-950 group-hover:text-primary-700">{a.title}</h3>
                <p className="mt-2 text-sm leading-6 text-foreground-700 line-clamp-2">{a.summary}</p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}